import { render, staticRenderFns } from "./hpLogo.vue?vue&type=template&id=451d557e&"
import script from "./hpLogo.vue?vue&type=script&lang=js&"
export * from "./hpLogo.vue?vue&type=script&lang=js&"
import style0 from "./hpLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports